/**
 * On Course Bunker Play Reducers
 */
import {
    OCTBUNKER_ACTION,
    ALL_OCTBUNKER,
    ADD_OCTBUNKER,
    FETCH_OCTBUNKER,
    EDIT_OCTBUNKER,
    DELETE_OCTBUNKER,
    FETCH_OCTBUNKERCHART,
    FETCH_BUNKERSHOTCHART
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    octbunkerlist:[],
    particularoctbunker:[],
    bunkerchart:[],
    bunkershotchart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case OCTBUNKER_ACTION:
            return { ...state, loading: true };       

        case ALL_OCTBUNKER:
            return { ...state, loading: false, octbunkerlist: action.payload };     
            
        case ADD_OCTBUNKER:
            return { ...state, loading: false };     
         
        case FETCH_OCTBUNKER:
            return { ...state, loading: false, particularoctbunker: action.payload };  
            
        case EDIT_OCTBUNKER:
            return { ...state, loading: false }; 
            
        case DELETE_OCTBUNKER:
            return { ...state, loading: false };     

        case FETCH_OCTBUNKERCHART:
            return { ...state, loading: false, bunkerchart: action.payload };  

        case FETCH_BUNKERSHOTCHART:
            return { ...state, loading: false, bunkershotchart: action.payload };  
        
        default: return { ...state };

     }
 }